import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ClipboardCheck } from "lucide-react";

/** Revisão de registro: registra quem revisou, quando e a observação — com auditoria. */
export default function ReviewDialog({ open, onOpenChange, entity = "registro", entityLabel = "", url, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(url, { note });
      toast.success("Revisão registrada");
      setNote("");
      onOpenChange(false);
      onDone?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="review-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <ClipboardCheck size={17} className="text-primary" /> Revisar {entity}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {entityLabel && <p className="text-sm font-medium">{entityLabel}</p>}
          <Textarea rows={4} value={note} onChange={(e) => setNote(e.target.value)} className="resize-none"
            placeholder="Observação da revisão (opcional) — o que foi analisado ou corrigido" data-testid="review-note-input" />
          <Button className="w-full" onClick={submit} disabled={busy} data-testid="review-submit-btn">
            {busy ? "Registrando..." : "Registrar revisão"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
